import {FILTER_URL} from './constants'

//const FILTER_URL="http://b2filtersaapi.bamboobox.in/filter";
// const FILTER_URL="http://localhost:3000/filter"

//const FILTER_URL=FILTER_URL

export function saveFilters(mode,attributeData,filterName,tenantId,ui) {    
    const bodyData = {
        "tenantId" : `${tenantId}`,
        "filterName" : filterName,
        "page" : `${ui}`
    };
    const attributeArray = attributeData.map((object) => {
        const obj = {...object};
        delete obj.isValid;
        delete obj.index;
        return {...obj,...bodyData};
    })    
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({mode:mode , data: attributeArray}),
        credentials:'include'
    };

    return fetch(`${FILTER_URL}/save-filter?tenantId=${tenantId}&&ui=${ui}`, requestOptions)
        .then(response => response.json())
        .catch(err => {
            console.error(err);
        })        
}

export function getFilterNames(tenantId,ui) {
    console.log("==getFilterNames==");
    return fetch(`${FILTER_URL}/get-filter?tenantId=${tenantId}&&ui=${ui}`,{credentials:'include'})
      .then(res => res.json())
      .catch(err => {
        console.error(err);
      })   
}

export function getFilterDataByName(filterName,tenantId,ui) {
    return fetch(`${FILTER_URL}/get-filter-byname?filterName=${filterName}&&tenantId=${tenantId}&&ui=${ui}`,{credentials:'include'})
    .then(res => res.json())
    .catch(err => {
      console.error(err);
    }) 
  }

export function deleteFilters(name,tenantId,ui) {
    const requestOptions = {
      method: 'POST',
      credentials:'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
         filterName: name,
         tenantId,
         page: ui
      })
    };
    return fetch(`${FILTER_URL}/delete-filter`, requestOptions)
      .then(response => response.json())
      .catch(err => {
          console.error(err);
      })    
  }